/** @format */

import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap styles
import Cookies from 'js-cookie';
import { useEffect, useRef, useState } from 'react';
import './Header.css'; // Import the CSS styles we created

//logo
import { useLocation } from 'react-router-dom';
import Logo from '../../../images/agentshades logo.png';
import { FaUserCircle } from 'react-icons/fa';
import { useAuth } from '../../../context/Auth.context';


function Header() {
  const location = useLocation();
  const currentPath = location.pathname;
  const [username, setUsername] = useState('');
  const [firstname, setfirstname] = useState('');

  const [logedIn, setLogedIn] = useState(false);
  const { state: { Admin } } = useAuth();

  const navData = {
    title: 'AGENTSHADES',
    links: [
      { name: 'Products', href: 'product' },
      { name: 'Templates', href: 'design' },
      { name: 'Pricing', href: 'pricing' },
      { name: 'Instruction', href: 'instruction' },
      { name: 'About Us', href: 'about' },
      { name: 'Contact', href: 'contactus' },
    ],
    button: {
      name: 'Sign Up',
      href: '/register',
      style: {
        background: 'white',
      },
    },
    dash: {
      name: 'Dashboard',
      href: `/dashboard/${Admin.isAdmin === false ? 'leadcount' : 'admin/activeagents'}`,
      style: {
        background: 'white',
      },
    },
  };

  useEffect(() => {
    const token = Cookies.get('token');
    const username = Cookies.get('username');
    const firstname = Cookies.get('firstname');
    if (token) {
      setLogedIn(true);
      setUsername(username);
      setfirstname(firstname);
    }
  }, []);
  const handleLogOut = () => {
    Cookies.remove('token');
    Cookies.remove('username');
    Cookies.remove('firstname');
    localStorage.clear();
    window.location.reload();
  };
  const [activeLink, setActiveLink] = useState('');
  const [navbarCollapsed, setNavbarCollapsed] = useState(true);

  const navbarRef = useRef<HTMLDivElement>(null);

  const toggleNavbar = () => {
    setNavbarCollapsed(!navbarCollapsed);
  };

  const handleCloseClick = () => {
    if (navbarRef.current && navbarRef.current.classList.contains('show')) {
      navbarRef.current.classList.add('closing');
      setTimeout(() => {
        if (navbarRef.current) {
          navbarRef.current.classList.remove('show');
        }
      }, 500);
    }
  };

  return (
    <nav className="nav_bar navbar navbar-expand-lg navbar-dark bg-light">
      <a
        className="navbar-brand"
        href="/">
        <img
          src={Logo}
          alt="Logo"
          className="Logo"
        />
        {navData.title}
      </a>
      <button
        className="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarSupportedContent"
        aria-controls="navbarSupportedContent"
        aria-expanded={!navbarCollapsed}
        aria-label="Toggle navigation"
        onClick={toggleNavbar}>
        <span className="navbar-toggler-icon"></span>
      </button>

      <div
        className={`collapse navbar-collapse justify-content-end ${navbarCollapsed ? '' : 'show'
          }`}
        id="navbarSupportedContent"
        ref={navbarRef}>
        <span
          className="navbar-close-icon"
          onClick={handleCloseClick}>
          X
        </span>
        <ul className="navbar-nav">
          {navData.links.map((link) => {
            if (link.name === 'Instruction' && logedIn) {
              return (
                <li
                  className={`nav-item ${currentPath.includes(link.href) ? 'active' : ''
                    }`}
                  key={link.name}>
                  <a
                    className="nav-link"
                    href={link.href}
                    onClick={() => {
                      setActiveLink(link.name);
                      toggleNavbar(); // Collapse navbar on mobile after clicking a link
                    }}>
                    {link.name}
                  </a>
                </li>
              );
            } else if (link.name !== 'Instruction') {
              return (
                <li
                  className={`nav-item ${currentPath.includes(link.href) ? 'active' : ''
                    }`}
                  key={link.name}>
                  <a
                    className="nav-link"
                    href={link.href}
                    onClick={() => {
                      setActiveLink(link.name);
                      toggleNavbar(); // Collapse navbar on mobile after clicking a link
                    }}>
                    {link.name}
                  </a>
                </li>
              );
            }

            return null;
          })}
          {/* Display firstname with user icon if logged in */}
          {logedIn && (
            <li className="nav-item">
              <span className="nav-link">
                <FaUserCircle className="user-icon" /> {firstname}
              </span>
            </li>
          )}

          <li
            className={`nav-item ${currentPath.includes('login') ? 'active' : ''
              }`}>
            {!logedIn ? (
              <a
                className="nav-link"
                href={'/login'}>
                Login
              </a>
            ) : (
              <a
                className="nav-link"
                href="#"
                onClick={handleLogOut}>
                Logout
              </a>
            )}
          </li>

          {logedIn ? (
            <li className="nav-item get_started_btn">
              <a
                className="btn btn-light"
                href={navData.dash.href}
                style={navData.dash.style}>
                {navData.dash.name}
              </a>
            </li>
          ) : (
            <li className="nav-item get_started_btn animation_get_started">
              <a
                className="btn btn-light"
                href={navData.button.href}
                style={navData.button.style}>
                {navData.button.name}
              </a>
            </li>
          )}
        </ul>
      </div>
    </nav>
  );
}

export default Header;
